import React, { Component, useState } from "react";
import { StyleSheet, View, ActivityIndicator } from "react-native";
import RequireIndicator from "../../components/RequireIndicator";
import GenderItem from "../../components/UpdateProfile/BasicInformation/GenderItem";
import Theme from "../../style/Theme";
import Header from "../../components/header";
import Footer from "../../components/footer";
import locales_es from "../../locales/es";
import Form from "../../components/form";
import APIService from "../../modules/apiService";
import Helpers from "../../modules/helpers";
import SearchMedicines from "../../components/searchMedicines";
import InputSpinner from "../../components/inputSpinner";
import Colors from "../../configs/Colors";
import ConfigService from "../../modules/configService";
import { showModalInfo, showModalInfoAction } from "../../modules/ViewHelpers";
import Text from "../../components/Text";
import { CommonStyles } from "../../styles/CommonStyles";
import { getAnalytics, logEvent } from "firebase/analytics";
import Clarity from "@microsoft/clarity";
import { WEBSITE_URL } from "../../models/constants";
import * as validator from "validator";
import DateTimeService from "../../modules/DateTimeService";
import { appHelpers } from "../../import";

function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default class PrescriptionRequestPage extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      lastname: "",
      email: "",
      phoneNumber: "",
      identification: "",
      identificationTypeId: "1",
      medicalInsuranceId: "",
      medicalInsurancePlan: "",
      medicalInsuranceNumber: "",
      medicalInsuranceName: "",
      medicId: { id: "" },
      comment: "",
      medicines: [],
      errors: [],
      sentRequest: false,
      visible: false,
      modalTitle: "",
      modalContent: "",
      loadingConfig: true,
      clinicData: {},
      identificationOptions: [],
      medicalInsurancesOptions: [],
      clinicMedics: [],
      prescriptionProfile: {},
      gender: null,
      gendersList: [],
      amount: 0,
      amountFormatted: "",
      showTerms: true,
      terms: "",
      policies: "",
      countries: {},
      termsAndPolicy: false,
      amountFormatted: "",
      debounceLoading: false,
      errorMessages: {},
      searchResetCounter: 0,
      birthDate: "",
      selectedDate: ""
    };

    this.nroFinanciador = 0;
    this.resetSearch = false;

    this.api = new APIService();
    this.helpers = new Helpers();
    this.configService = new ConfigService();
    this.dateService = new DateTimeService();
    this.analytics = getAnalytics();
    this.clarity = this.props.clarity;
    this.validateEmailDebounce = debounce(this.validateSmtpDomain, 1000);
  }

  componentDidMount() {
    // Oculta Intercom mediante CSS
    if (window && window.document) {
      window.document.body.classList.add("rcta-hide-intercom");
    }

    this.load();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.clinicData.hasMedicPaylinkEnabled &&
      this.state.medicId.id !== prevState.medicId.id
    ) {
      this.api.getPrescriptionsProfiles(this.state.medicId.id).then((res5) => {
        const prescriptionProfiles = res5.data;
        const [paymentAccount] = prescriptionProfiles.filter(
          (item) =>
            item.active_charger_account === 1 &&
            item.clinic_id == this.state.clinicData.id
        );
        this.setState({
          prescriptionProfile: paymentAccount,
          amount:
            this.state.clinicData && this.state.clinicData.hasPaylink
              ? this.state.clinicData.paylink_amount
              : paymentAccount.charger_accounts.amount,
          amountFormatted:
            this.state.clinicData && this.state.clinicData.hasPaylink
              ? this.formatAmount(
                  this.state.clinicData.paylink_amount,
                  2,
                  ",",
                  "."
                )
              : this.formatAmount(
                  paymentAccount.charger_accounts.amount,
                  2,
                  ",",
                  "."
                ),
        });
      });
    }
  }

  formatAmount(number, decimals, decPoint, thousandsSep) {
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
    const dec = typeof decPoint === "undefined" ? "." : decPoint;
    let s = "";

    const toFixedFix = function (n, prec) {
      if (("" + n).indexOf("e") === -1) {
        return +(Math.round(n + "e+" + prec) + "e-" + prec);
      } else {
        const arr = ("" + n).split("e");
        let sig = "";
        if (+arr[1] + prec > 0) {
          sig = "+";
        }
        return (+(
          Math.round(+arr[0] + "e" + sig + (+arr[1] + prec)) +
          "e-" +
          prec
        )).toFixed(prec);
      }
    };

    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec).toString() : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }

    return s.join(dec);
  }

  load() {
    this.api
      .getGenders()
      .then((res) => {
        const data = res.data;
        this.setState({ gendersList: data, gender: null });
      })
      .catch((err) => {
        this.props.showMainModal(
          locales_es.errorModal.title,
          this.helpers.getErrorMsg(err)
        );
      });

    this.configService
      .getLocalClinicData()
      .then((res) => {
        this.setState(
          {
            clinicData: {
              id: res.id,
              countryId: res.country_id,
              name: res.name,
              logo: res.full_logo_image,
              hasPaylink: res.paylink_enabled && res.paylink_url,
              hasMedicPaylinkEnabled: res.paylink_enabled && !res.paylink_url,
              paylink_enabled: res.paylink_enabled,
              paylink_url: res.paylink_url,
              paylink_reason: res.paylink_reason,
              paylink_amount: res.paylink_amount,
            },
            amount:
              res.paylink_enabled && res.paylink_url
                ? res.paylink_amount
                : this.state.prescriptionProfile &&
                  this.state.prescriptionProfile.charger_accounts
                ? this.state.prescriptionProfile.charger_accounts.amount
                : 0,
            amountFormatted:
              res.paylink_enabled && res.paylink_url
                ? this.formatAmount(res.paylink_amount, 2, ",", ".")
                : this.state.prescriptionProfile &&
                  this.state.prescriptionProfile.charger_accounts
                ? this.formatAmount(
                    this.state.prescriptionProfile.charger_accounts.amount,
                    2,
                    ",",
                    "."
                  )
                : "",
          },
          () => {
            this.api
              .getIdentificationTypesByCountryId(
                this.state.clinicData.countryId
              )
              .then((res2) => {
                this.setState(
                  {
                    identificationOptions: res2.data,
                  },
                  () => {
                    this.api
                      .getMedicalInsurances()
                      .then((res3) => {
                        if (res3.data.length > 0) {
                          res3.data[0].name = "Sin cobertura";
                        }
                        this.setState(
                          {
                            medicalInsurancesOptions: res3.data.map((item) => {
                              item.label = item.name;
                              item.value = item.id;
                              return item;
                            }),
                          },
                          () => {
                            this.api
                              .getMedicsByClinic(this.state.clinicData.id)
                              .then((res4) => {
                                this.setState(
                                  {
                                    clinicMedics: res4.data.map((item) => {
                                      //TODO implementar item.professional_prefix_id
                                      item.label = `${item.name} ${item.lastname}`;
                                      item.value = item.id;
                                      return item;
                                    }),
                                  },
                                  () => {
                                    this.props.hideMainLoading();
                                    this.props.parseTelInputs();
                                    this.api
                                      .getCountries()
                                      .then((res) => {
                                        const currentCountry = res.data.find(
                                          (c) =>
                                            c.id ===
                                            this.state.clinicData.countryId
                                        );
                                        const termsPage = currentCountry
                                          ? `${currentCountry.terms_and_conditions_url}?v=${process.env.REACT_APP_VERSION}`
                                          : WEBSITE_URL;
                                        const privacyPoliciesPage =
                                          currentCountry
                                            ? `${currentCountry.privacy_policies_url}?v=${process.env.REACT_APP_VERSION}`
                                            : WEBSITE_URL;
                                        this.setState({
                                          countries: res.data,
                                          terms: termsPage,
                                          policies: privacyPoliciesPage,
                                        });
                                      })
                                      .catch((err) => {
                                        this.props.showMainModal(
                                          locales_es.errorModal.title,
                                          this.helpers.getErrorMsg(err)
                                        );
                                      });
                                  }
                                );
                              })
                              .catch((err) => {
                                this.props.hideMainLoading();
                                this.props.showMainModal(
                                  locales_es.errorModal.title,
                                  this.helpers.getErrorMsg(err)
                                );
                              });
                          }
                        );
                      })
                      .catch((err) => {
                        this.props.hideMainLoading();
                        this.props.showMainModal(
                          locales_es.errorModal.title,
                          this.helpers.getErrorMsg(err)
                        );
                      });
                  }
                );
              })
              .catch((err) => {
                this.props.hideMainLoading();
                this.props.showMainModal(
                  locales_es.errorModal.title,
                  this.helpers.getErrorMsg(err)
                );
              });
          }
        );
      })
      .catch((err) => {
        this.props.hideMainLoading();
        console.log(locales_es.errorModal.title);
        console.log(this.helpers.getErrorMsg(err));
        this.props.showMainModal(
          locales_es.errorModal.title,
          this.helpers.getErrorMsg(err)
        );
      });
  }

  resetState = () => {
    this.setState({
      name: "",
      lastname: "",
      email: "",
      phoneNumber: "",
      identification: "",
      identificationTypeId: "1",
      medicalInsuranceId: "",
      medicalInsurancePlan: "",
      medicalInsuranceNumber: "",
      medicalInsuranceName: "",
      medicId: { id: "" },
      comment: "",
      medicines: [],
      errors: [],
      sentRequest: false,
      visible: false,
      modalTitle: "",
      modalContent: "",
      loadingConfig: true,
      gender: "",
      amount: 0,
      amountFormatted: "",
      birthDate: "",
      selectedDate: "",
      termsAndPolicy: false,
    });
  };

  clearErrors() {
    this.setState({ errors: [] });
  }

  removeFromErrors(string) {
    let errors = JSON.parse(JSON.stringify(this.state.errors));
    errors = errors.filter((item) => item !== string);
    this.setState({
      errors,
    });
  }

  validateSmtpDomain() {
    const emailError = this.state.errors.includes("email") ? true : false;
    if (emailError || this.state.loading === true) return;

    const atIndex = this.state.email.indexOf("@");

    if (atIndex > -1 && this.state.email.length > atIndex + 1) {
      const objetData = {
        email: this.state.email,
      };
      this.setState({ loading: true }, () => {
        this.api
          .validateSmtpDomain(objetData)
          .then((resp) => {
            this.removeFromErrors("email");
          })
          .catch((error) => {
            this.setState((prevState) => ({
              errors: [...prevState.errors, "email"],
              errorMessages: {
                ...prevState.errorMessages,
                email: `${this.helpers.getErrorMsg(error)}`,
              },
            }));
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      });
    }
  }

  handleCheckChange() {
    this.setState((prevState) => {
      let newTermsAndPolicy = !prevState.termsAndPolicy;

      logEvent(
        this.analytics,
        "patient_prescription_request_accept_terms_and_policy_click",
        {
          checked: newTermsAndPolicy ? "enabled" : "disabled",
        }
      );

      this.clarity.event(
        "patient_prescription_request_accept_terms_and_policy_click",
        {
          checked: newTermsAndPolicy ? "enabled" : "disabled",
        }
      );

      return { termsAndPolicy: newTermsAndPolicy };
    });
  }

  handleChange = (state) => (ev) => {
        
    let value = ev.target.value;
    if (state === "identification") {
      value = value.toUpperCase();
    }

    this.setState({ [state]: value });
    this.validateFormReactive(state, value);

    if (state === "email") {
      this.validateEmailDebounce();
    }
  };

  validateFormReactive = (state, value) => {
    let isValid = true;
    let errorMessage = "";

    const fieldNames = {
      email: "El email",
      phoneNumber: "El Número de teléfono",
      identification: "La Identificación",
      name: "El Nombre",
      lastname: "El Apellido",
      medicalInsurancePlan: "El plan de seguro médico",
      medicalInsuranceNumber: "El número de seguro médico",
    };

    const typeDocs = {
      1: "DNI",
      2: "Libreta de enrolamiento",
      3: "Libreta cívica",
      4: "CI",
      5: "Pasaporte",
      9: "CI",
      10: "Pasaporte"
    };

    if (
      (!value || value.trim() === "") &&
      state !== "medicalInsurancePlan" &&
      state !== "medicalInsuranceNumber" &&
      state !== "medicalInsuranceId" &&
      state !== "medicalInsuranceDniTitular" &&
      state !== "phoneNumber"
    ) {
      errorMessage = `Campo obligatorio`;
      isValid = false;
    } else {
      if (state === "email") {
        const isEmail = validator.default.isEmail(value, {
          blacklisted_chars: "+",
        });
        const emailLength = value.length;
        if (emailLength >= 1) {
          isValid = isEmail && emailLength >= 8 && emailLength <= 75;
        }

        if (!isValid) {
          if (emailLength < 8) {
            errorMessage = `${fieldNames[state]} debe contener al menos 8 caracteres`;
          }

          if (!isEmail) {
            errorMessage = `El Campo debe ser un email valido.`;
          }

          if (emailLength > 75) {
            errorMessage = `${fieldNames[state]} debe contener menos de 75 caracteres`;
          }
        }
      }

      if (state === "phoneNumber") {
        const phoneRegex = /^[0-9]+$/;
        const phoneLength = value.length;
        if (phoneLength > 1) {
          isValid =
            phoneRegex.test(value) && phoneLength >= 6 && phoneLength <= 12;
        }

        if (!isValid) {
          if (!phoneRegex.test(value)) {
            errorMessage = `${fieldNames[state]} solo puede contener números`;
          }

          if (phoneLength < 6) {
            errorMessage = `${fieldNames[state]} debe contener al menos 6 caracteres`;
          }
          if (phoneLength > 12) {
            errorMessage = `${fieldNames[state]} debe contener menos de 12 caracteres`;
          }
        }
      }

      if (state == "identificationTypeId" && this.state.identification === "") {
        return;
      }

      if (state === "identification" || state === "identificationTypeId") {

        const identValue = state === "identificationTypeId" ? this.state.identification : value;
        const identificationType = typeDocs[this.state.identificationTypeId];

        [errorMessage, isValid] = appHelpers.validateIdentificationV2(
          identValue,
          identificationType,
          state === "identificationTypeId" ? "identification" : state
        );

        state = "identification";
      }

      if (state == "name" || state === "lastname") {
        const nameRegex = /^[a-zA-Z\sáéíóúÁÉÍÓÚüÜñÑ'´`]+$/;
        const nameLength = value.length;
        isValid = nameRegex.test(value) && nameLength >= 2 && nameLength <= 50;
        if (!isValid) {
          if (!nameRegex.test(value) && nameLength >= 2) {
            errorMessage = `${fieldNames[state]} solo puede contener letras`;
          }
          if (nameLength < 2) {
            if (errorMessage.includes("solo puede contener letras")) {
              errorMessage = `${fieldNames[state]} debe contener al menos 2 caracteres y solo puede contener letras`;
            }
            errorMessage = `${fieldNames[state]} debe contener al menos 2 caracteres`;
          }
          if (nameLength > 50) {
            errorMessage = `${fieldNames[state]} debe contener menos de 50 caracteres`;
          }

          if (nameLength == 0) {
            errorMessage = `Campo obligatorio`;
          }
          if (!nameRegex.test(value) && nameLength < 2) {
            errorMessage = `${fieldNames[state]} solo puede contener letras y debe contener al menos 2 caracteres`;
          }
        }
      }

      if (state === "birthDate") {
        const dateParse = this.dateService.parseDateToAPIString(value);
        console.log("dateParse", dateParse);
        this.setState({ birthDate: dateParse });
    }

    }

    if (this.state.medicalInsuranceId) {
      const data = value;
      if (
        this.state.medicalInsuranceId.id !== 1 &&
        state == "medicalInsuranceNumber" &&
        data.length == 0
      ) {
        errorMessage = `Campo obligatorio`;
        isValid = false;
      }
    }

    if (state === "birthDate") {
      if (!value) {
        errorMessage = `Campo obligatorio`;
        isValid = false;
      }

    }

    if (!isValid) {
      this.setState((prevState) => ({
        errors: [...prevState.errors, state],
        errorMessages: { ...prevState.errorMessages, [state]: errorMessage },
      }));
    } else {
      this.removeFromErrors(state);
    }
  };

  selectMedicalIInsuranceNone = (medic) => {
    if (medic.insurancePermission == false) {
      const insuranceNone = this.state.medicalInsurancesOptions.find(
        (item) => item.name == "Sin cobertura"
      );
      this.setState({ medicalInsuranceId: insuranceNone });
      this.setState({ medicalInsurancePlan: "" });
      this.setState({ medicalInsuranceNumber: "" });
      this.setState({ medicalInsuranceName: insuranceNone.name });
    }
  };

  handleReactSelectChange = (state) => (value) => {
    if (state === "medicId") {
      this.selectMedicalIInsuranceNone(value);
      this.setState({ [state]: value });
    } else if (state === "medicalInsuranceId" && value) {
      if (value.idFinanciador > 0 && value.tieneCobertura == 1) {
        showModalInfoAction(
          locales_es.confirmChangueCobertura.title,
          locales_es.confirmChangueCobertura.subtitle,
          [
            {
              text: locales_es.confirmChangueCobertura.accept,
              onPress: () => {
                this.nroFinanciador = 0;
                if (value.idFinanciador > 0 && value.tieneCobertura == 1) {
                  this.nroFinanciador = value.idFinanciador;
                }
                this.setState({ medicines: [] });
                this.setState({ medicalInsuranceName: value.name });
                this.setState({ [state]: value });
                this.resetSearch = true;
              },
              white: true,
            },
            {
              text: locales_es.confirmChangueCobertura.cancel,
              onPress: () => console.log("Cancel Pressed"),
              white: true,
              colors: [Colors.Tomato, Colors.Red],
            },
          ]
        );
      } else {
        this.nroFinanciador = 0;
        if (value.idFinanciador > 0 && value.tieneCobertura == 1) {
          this.nroFinanciador = value.idFinanciador;
        }
        this.setState({ medicalInsuranceName: value.name });
        this.setState({ [state]: value });
        this.resetSearch = true;
      }
    } else {
      this.setState({ [state]: value });
    }
  };

  handleOpenPaymentLink = () => {
    let link = this.state.clinicData.hasPaylink
      ? this.state.clinicData.paylink_url
      : this.state.prescriptionProfile.charger_accounts.pay_link;

    link = link.replace(/^https?:\/?\/?/i, "");

    link = `https://${link}`;
    window.open(link, "_blank");
  };

  handleDateChange = (state) => (value) => {
    this.setState({ [state]: value });
    const parsedDate = this.dateService.parseDateToAPIString(value);
    this.setState({ birthDate: parsedDate });
  };

  render() {

    const { medicines, errors, errorMessages } = this.state;
    const _errors = errors;
    const classNameError = this.props.classNameError;

    const inputs = [
      {
        label: locales_es.name,
        placeholder: locales_es.fullName,

        id: 1,
        state: "name",
        value: this.state.name,
        type: "name",
        required: true,
        wrapperCustomClassName: "form-group col-6 col-md-6 float-left pl-md-0",
        customClassName: errors.includes("name") && classNameError,
        error: _errors.includes("name") && classNameError,
        errorMessage: _errors.includes("name") ? errorMessages["name"] : null,
        validate: true,
      },
      {
        label: locales_es.lastname,
        placeholder: locales_es.lastname,

        id: 2,
        state: "lastname",
        value: this.state.lastname,
        type: "lastname",
        required: true,
        wrapperCustomClassName: "form-group col-6 col-md-6 float-left pr-md-0",
        customClassName: _errors.includes("lastname")
          ? classNameError
          : _errors.includes("name")
          ? " mb-4"
          : null,
        error: _errors.includes("lastname") && classNameError,
        errorMessage: _errors.includes("lastname")
          ? errorMessages["lastname"]
          : null,
        validate: true,
      },
      {
        label: locales_es.email,
        placeholder: locales_es.email,

        id: 3,
        state: "email",
        value: this.state.email,
        type: "email",
        required: true,
        wrapperCustomClassName: "form-group col-6 col-md-6 float-left pl-md-0",
        customClassName: _errors.includes("email") && classNameError,
        errorMessage: _errors.includes("email") ? errorMessages["email"] : null,
        error: _errors.includes("email") && classNameError,
        validate: true,
      },
      {
        label: locales_es.phoneNumber,
        placeholder:
          locales_es[`phoneNumberExample_${this.state.medicCountryCode}`] ||
          locales_es.phoneNumberExample,

        id: 4,
        state: "phoneNumber",
        value: this.state.phoneNumber,
        type: "number",
        required: false,
        wrapperCustomClassName: "form-group col-6 col-md-6 float-left pr-md-0",
        customClassName:
          "cellphoneInput " +
          (_errors.includes("phoneNumber")
            ? classNameError
            : _errors.includes("email")
            ? " mb-4"
            : null),
        errorMessage: _errors.includes("phoneNumber")
          ? errorMessages["phoneNumber"]
          : null,
        error: _errors.includes("phoneNumber") && classNameError,
        validate: true,
      },
      {
        label: locales_es.birthDate,
        placeholder: locales_es.birthDateExample,
        onBlur: () => this.removeFromErrors("birthDate"),
        id: 11,
        state: "selectedDate",
        value: this.state.selectedDate,
        type: "date",
        required: true,
        wrapperCustomClassName:
          "form-group col-6 col-md-6 float-left pl-md-0",
        customClassName: _errors.includes("selectedDate") && classNameError,
        maxDate: new window.Date().getTime(),
        errorMessage: _errors.includes("birthDate")
          ? errorMessages["birthDate"]
          : null,
        // hideCalendar: true,
      },
    ];

    const inputsIdentification = [
      {
        label: locales_es.identificationType,
        placeholder: locales_es.identificationType,
        onBlur: () => this.removeFromErrors("identificationTypeId"),
        id: 5,
        state: "identificationTypeId",
        value: this.state.identificationTypeId,
        type: "select",
        required: true,
        options: this.state.identificationOptions,
        wrapperCustomClassName:
          "form-group col-12 col-md-3 float-left pl-md-0 mt-1",
        customClassName:
          errors.includes("identificationTypeId") && classNameError,
      },
      {
        label: locales_es.identification,
        placeholder: locales_es.identification,
        id: 6,
        state: "identification",
        value: this.state.identification,
        type: "text",
        required: true,
        wrapperCustomClassName: "form-group col-12 col-md-3 float-left pl-md-0 clear mt-1",
        customClassName: errors.includes("identification") && classNameError,
        error: errors.includes("identification") && classNameError,
        errorMessage: errors.includes("identification")
          ? this.state.errorMessages["identification"]
          : null,
        validate: true,
      }
      ,
    ];

    const inputsInsurance = [
      {
        label: locales_es.medicalInsurance,
        placeholder: locales_es.medicalInsurance,
        onBlur: () => this.removeFromErrors("medicalInsuranceId"),
        id: 7,
        state: "medicalInsuranceId",
        value: this.state.medicalInsuranceId,
        disabled:
          this.state.medicId &&
          this.state.medicId.insurancePermission === false,
        type: "react-select",
        required: this.state.medicalInsuranceId && this.state.medicalInsuranceId.label?.toLowerCase() !== "seleccionar" &&  this.state.medicalInsuranceId.value != -1 ? true : false,
        options: this.state.medicalInsurancesOptions,
        wrapperCustomClassName:
          "form-group col-12 col-md-4 float-left pl-md-0 clear",
        customClassName:
          errors.includes("medicalInsuranceId") && classNameError,
      },
      {
        label: locales_es.medicalInsurancePlan,
        placeholder: locales_es.medicalInsurancePlan,

        id: 8,
        disabled:
          this.state.medicId &&
          this.state.medicId.insurancePermission === false,
        state: "medicalInsurancePlan",
        value: this.state.medicalInsurancePlan,
        required: false,
        wrapperCustomClassName: "form-group col-12 col-md-4 float-left pl-md-0",
        customClassName:
          errors.includes("medicalInsurancePlan") && classNameError,
        visible: this.state.medicalInsuranceName.toLocaleLowerCase() !== "mpn - medicamentos de primer nivel" && this.state.medicalInsuranceName.toLocaleLowerCase() !== 'sin cobertura' && this.state.medicalInsuranceName.toLocaleLowerCase() !== "" && this.state.medicalInsuranceName.toLocaleLowerCase() !== 'ioscor',
      },
      {
        label: locales_es.medicalInsuranceNumber,
        placeholder: locales_es.medicalInsuranceNumber,

        id: 9,
        disabled:
          this.state.medicId &&
          this.state.medicId.insurancePermission === false,
        state: "medicalInsuranceNumber",
        value: this.state.medicalInsuranceNumber,
        required:
          this.state.medicalInsuranceId &&
          this.state.medicalInsuranceId.length &&
          this.state.medicalInsuranceName.toLocaleLowerCase() !==
            "mpn - medicamentos de primer nivel" &&
          this.state.medicalInsuranceName?.toLocaleLowerCase() !== "sin cobertura" && this.state.medicalInsuranceName?.toLocaleLowerCase() !== "ninguna" && this.state.medicalInsuranceId?.value != -1 && this.state.medicalInsuranceId?.label.toLocaleLowerCase() != "seleccionar" && this.state.medicalInsuranceName.toLocaleLowerCase() !== 'ioscor'
            ? true
            : false,
        wrapperCustomClassName:
          "form-group col-12 col-md-4 float-left pl-md-0 clearfix",
        customClassName:
          errors.includes("medicalInsuranceNumber") && classNameError,
        visible: this.state.medicalInsuranceName.toLocaleLowerCase() !== "mpn - medicamentos de primer nivel" && this.state.medicalInsuranceName.toLocaleLowerCase() !== 'sin cobertura' && this.state.medicalInsuranceName.toLocaleLowerCase() !== "" && this.state.medicalInsuranceName.toLocaleLowerCase() !== 'ioscor',
      },
    ];

    const inputsPrescription = [
      {
        label: locales_es.selectMedicToRequestPrescription,
        placeholder: locales_es.selectMedic,
        onBlur: () => this.removeFromErrors("medicId"),
        id: 10,
        state: "medicId",
        value: this.state.medicId,
        type: "react-select",
        required: true,
        options: this.state.clinicMedics,
        wrapperCustomClassName: "form-group col-sm-8 col-md-4 pl-md-0",
        customClassName: errors.includes("medicId") && classNameError,
      },
    ];

    const onSelectItem = (selectedItem, selectedPresentationIndex) => {
      this.clearErrors();
      selectedItem.qubito_reg_no =
        selectedItem.presentations[selectedPresentationIndex].qubito_reg_no;
      selectedItem.presentation =
        selectedItem.presentations[selectedPresentationIndex].name;
      selectedItem.quantity = 1;
      selectedItem.comment = "";
      selectedItem.is_generic = false;
      addMedicine(selectedItem);
    };

    const addMedicine = (item) => {
      const medicines = JSON.parse(JSON.stringify(this.state.medicines));
      medicines.push(item);
      this.setState({
        medicines,
      });
    };

    const openSearchMedicines = () => {
      this.setState(
        (prevState) => ({
          searchResetCounter: prevState.searchResetCounter + 1,
        }),
        () => {
          this.props.showMainModal(
            null,
            <SearchMedicines
              showMainModal={this.props.showMainModal}
              isPublic={true}
              nroFinanciador={this.nroFinanciador}
              onSelectItem={onSelectItem}
              resetSearch={this.state.searchResetCounter}
            />,
            null,
            null,
            "modal-lg"
          );
        }
      );
    };

    const renderMedicine = (item, index) => {
      const sumQuantity = (qty) => {
        const _medicines = JSON.parse(JSON.stringify(this.state.medicines));
        const medicine = _medicines[index];
        medicine.quantity += qty;

        this.setState({
          medicines: _medicines,
        });
      };

      const setMedicineComment = (index, text) => {
        const _medicines = JSON.parse(JSON.stringify(medicines));
        _medicines[index].comment = text;
        this.setState({
          medicines: _medicines,
        });
      };

      const removeMedicine = (index) => {
        const _medicines = JSON.parse(JSON.stringify(medicines));
        _medicines.splice(index, 1);
        this.setState({
          medicines: _medicines,
        });
      };

      return (
        <div key={"render-medicine-" + index}>
          {index >= 1 && <hr />}
          <div className="mb-3">
            <button
              onClick={() => removeMedicine(index)}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="icofont-close-line" />
            </button>
            <h6>
              <span className="item-icon icofont-drug" />
              &nbsp;
              <span
                className={
                  item.is_generic ? "text-decoration-line-through" : ""
                }
              >
                {item.commercial_name}
              </span>
              &nbsp;
              <span>
                ({item.drug}) {item.presentation}
              </span>
            </h6>
            {/*<div className="row justify-content-center">
              <div className="custom-control custom-switch mb-3">
                <input onChange={() => onSwitchPress(index)} type="checkbox" className="custom-control-input"
                       id={`customCheck-${index}`}
                       checked={item.is_generic}/>
                <label className="custom-control-label"
                       htmlFor={`customCheck-${index}`}>{locales_es.prescriptGenericOnly}</label>
              </div>
            </div>*/}
            <div className="row justify-content-center">
              <div className="col col-md-6">
                <div className="form-group w-100">
                  <input
                    className="form-control"
                    type="text"
                    placeholder={
                      locales_es.clarifiesThisMedicine +
                      " (" +
                      locales_es.optional +
                      ")"
                    }
                    disabled={false}
                    onChange={(e) => setMedicineComment(index, e.target.value)}
                    value={item.comment}
                  />
                </div>
              </div>
            </div>
            <div>{locales_es.quantity}</div>
            <div
              style={{
                maxWidth: "240px",
                margin: "auto",
                transform: "scale(0.75)",
              }}
            >
              <InputSpinner
                max={99}
                min={1}
                step={1}
                colorMax={Colors.Tomato}
                colorMin={Colors.TealBlue}
                color={Colors.TealBlue}
                value={Number(item.quantity)}
                // skin="modern"
                onChange={(num) => sumQuantity(num)}
              />
            </div>
          </div>
        </div>
      );
    };

    const validateForm = () => {
      let errors = [];
      this.clearErrors();
      inputs.map((input) => {
        if (input.required && !this.state[input.state]) {
          errors.push(input.state);
        }
      });

      inputsIdentification.map((input) => {
        if (input.required && !this.state[input.state]) {
          errors.push(input.state);
        }
        if (input.state == "identification" && !errors.some(x => x == 'identification')) {
          const identificationType = this.state.identificationOptions.find(x => x.id == this.state.identificationTypeId);
          const [errorMessage, isValid] = appHelpers.validateIdentificationV2(
            this.state.identification,
            identificationType.name
          );
          if (!isValid) {
            errors.push(input.state);
          }
        }
      });

      inputsInsurance.map((input) => {
        
        if (this.state.medicalInsuranceId && input.required && !this.state[input.state]) {
          errors.push(input.state);
        }
      });

      inputsPrescription.map((input) => {
        if (input.required && !this.state[input.state]) {
          errors.push(input.state);
        }
      });

      if (!this.state.gender || !this.state.gender.id) {
          errors.push("gender");
     }

      if (!this.state.medicines.length) {
        errors.push("medicines");
        this.props.showMainModal(
          locales_es.infoModal.title,
          "Añada al menos un medicamento para recetar"
        );
      }
      if (
        this.state.medicalInsuranceId &&
        !this.state.medicalInsuranceNumber.length &&
        this.state.medicalInsuranceName.toLocaleLowerCase() !==
          "mpn - medicamentos de primer nivel" && this.state.medicalInsuranceName.toLocaleLowerCase() !== 'sin cobertura' && this.state.medicalInsuranceName.toLocaleLowerCase() !== 'ioscor'
      ) {
        if (this.state.medicalInsuranceId.id > 1) {
          errors.push("medicalInsuranceNumber");
          this.props.showMainModal(
            locales_es.infoModal.title,
            "Añada su Nro. de afiliado"
          );
        }
      }

      // if (!this.state.medicalInsuranceId) {
      //   errors.push("medicalInsuranceId");
      //   this.props.showMainModal(
      //     locales_es.infoModal.title,
      //     "Elija una cobertura"
      //   );
      // }

      if (!this.state.birthDate){
        errors.push("birthDate");
        this.props.showMainModal(
          locales_es.infoModal.title,
          "Debe ingresar su fecha de nacimiento"
        );
      }
      
      //TODO link a terminos y condiciones dinámico
      //if (this.state.acceptedTerms !== true) {
      //  errors.push('acceptedTerms');
      //this.props.showMainModal(locales_es.infoModal.title, 'Debes aceptar los términos y condiciones');
      //}

      this.setState({
        errors,
      });
      return !errors.length;
    };

    const onSubmitPrescriptionForm = () => {
      if (!this.state.termsAndPolicy) {
        this.props.showMainModal(
          locales_es.infoModal.title,
          "Acepte los términos y condiciones y las políticas de privacidad para continuar"
        );
        return;
      }
      if (validateForm()) {
        this.setState({ sentRequest: true });

        const data = {
          clinic_id: this.state.clinicData.id,
          patient_name: this.state.name,
          patient_lastname: this.state.lastname,
          patient_email: this.state.email,
          patient_prefix_cell_phone: "+54 9", //TODO implementar en form
          patient_cell_phone: this.state.phoneNumber,
          patient_identification_type_id: this.state.identificationTypeId,
          patient_identification: this.state.identification,
          patient_gender: this.state.gender.id,
          patient_medical_insurance_id: this.state.medicalInsuranceId.id,
          patient_medical_insurance_plan: this.state.medicalInsurancePlan,
          patient_medical_insurance_number: this.state.medicalInsuranceNumber,
          medic_id: this.state.medicId.id,
          medicines: this.state.medicines,
          comments: this.state.comment,
          birth_date: this.state.birthDate,
        };

        this.api
          .postMedicalPrescriptionRequest(data)
          .then((res) => {
            const { clinicData, prescriptionProfile } = this.state;
            if (
              clinicData.hasPaylink ||
              (clinicData.hasMedicPaylinkEnabled &&
                prescriptionProfile &&
                prescriptionProfile.charger_accounts)
            ) {
              this.props.showMainModal(
                locales_es.successModal.title,
                <SuccessModalContent />
              );
            } else {
              this.props.showMainModal(
                locales_es.successModal.title,
                locales_es.sentPrescriptionRequestSuccessfully
              );
            }
            this.resetState();
          })
          .catch((err) => {
            this.props.showMainModal(
              locales_es.errorModal.title,
              this.helpers.getErrorMsg(err)
            );
            this.setState({ sentRequest: false });
          });
      } else {
        this.props.showMainModal(
          locales_es.errorModal.title,
          locales_es.errorModal.completeAllRequiredFormFields
        );
      }
    };

    const SuccessModalContent = () => {
      const { clinicData, prescriptionProfile } = this.state;
      let amountText = "";
      if (this.state.amount != 0) {
        const amountFormatted = this.state.amountFormatted;
        amountText = `$ ${amountFormatted}`;
      }
      return (
        <div
          className={
            "clear flex-wrap text-center justify-content-center justify-content-md-around mb-5 "
          }
        >
          <p>
            {/* Dada la situación actual del sistema de salud, los profesionales
            estan cobrando un bono de compensación del acto profesional. {"\n"}
            Para la generación de la receta, debe hacer una contribución de ${" "}
            {this.state.prescriptionProfile.charger_accounts.amount} {"\n"} */}
            {this.state.clinicData && this.state.clinicData.hasPaylink
              ? this.state.clinicData.paylink_reason
              : this.state.prescriptionProfile.charger_accounts.reason}{" "}
            {"\n"} {amountText} {"\n"}
          </p>
          <button
            type="button"
            onClick={() => this.handleOpenPaymentLink()}
            className="btn btn-primary"
          >
            Link de pago del profesional
          </button>
        </div>
      );
    };

    const handleTermsClick = () => {
      logEvent(
        this.analytics,
        "patient_prescription_request_terms_and_conditions_click"
      );

      this.clarity.event(
        "patient_prescription_request_terms_and_conditions_click"
      );
    };

    const handlePoliciesClick = () => {
      logEvent(
        this.analytics,
        "patient_prescription_request_privacy_policy_click"
      );

      this.clarity.event("patient_prescription_request_privacy_policy_click");
    };

    const preSendForm = () => {
      const insurancesNone = this.state.medicalInsurancesOptions.find(option => option.label?.toLowerCase() === "sin cobertura" || option.label?.toLowerCase() === "ninguna");
      
      if (!this.state.medicalInsuranceId) {
        this.setState({ medicalInsuranceId: insurancesNone, medicalInsuranceName: insurancesNone.name ?? insurancesNone.label }, () => {onSubmitPrescriptionForm()});
        return;
      }

      onSubmitPrescriptionForm();

    };

    return (
      <>
        <div className="app-loader">
          <i className="icofont-spinner-alt-4 rotate" />
        </div>
        {this.state.clinicData ? (
          <Header clinicData={this.state.clinicData} />
        ) : null}

        <div className="page-box w-100">
          <div className="app-container">
            <main className="main-content pb-5">
              <div className="main-content-wrap">
                <header className="page-header">
                  <h1 className="page-title">
                    Formulario de Solicitud de Recetas Online
                  </h1>
                </header>

                <div className="page-content">
                  <p>
                    Ingrese por favor los datos solicitados para poder
                    confeccionar su receta.
                    <br />
                    <br />
                    Verifique que los datos ingresados sean correctos antes de
                    confirmar la solicitud, en caso de estar mal ingresados, su
                    receta no podrá ser confeccionada.
                    <br />
                    <br />
                    Una vez que esté lista su receta, recibirá un e-mail de
                    notificación para poder pasar a retirarla.
                    <br />
                    <br />
                    TODOS LOS CAMPOS SON OBLIGATORIOS, excepto observaciones.
                  </p>
                  <hr />
                  <div className="card">
                    <div className="card-header">Seleccione el profesional</div>
                    <Form
                      style={"mt-3 mb-5"}
                      inputs={inputsPrescription}
                      handleChange={this.handleChange}
                      handleReactSelectChange={this.handleReactSelectChange}
                    />
                    {this.state.medicId.id &&
                    this.state.clinicData &&
                    (this.state.clinicData.hasPaylink ||
                      (this.state.clinicData.hasMedicPaylinkEnabled &&
                        this.state.prescriptionProfile &&
                        this.state.prescriptionProfile.charger_accounts)) ? (
                      <div
                        className={
                          "clear flex-wrap text-center justify-content-center justify-content-md-around mb-5 "
                        }
                      >
                        <p>
                          {this.state.clinicData.hasPaylink
                            ? this.state.clinicData.paylink_reason
                            : this.state.prescriptionProfile.charger_accounts
                                .reason}
                          {this.state.amount != 0
                            ? ` $ ${this.state.amountFormatted}`
                            : ``}
                          {"\n"}
                        </p>
                        <button
                          type="button"
                          onClick={() => this.handleOpenPaymentLink()}
                          className="btn btn-primary"
                          disabled={this.state.sentRequest}
                        >
                          Link de pago del profesional
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <div className="card">
                    <div className="card-header">Información Básica</div>

                    <Form
                      style={"mt-3"}
                      inputs={inputs}
                      handleChange={this.handleChange}
                      handleReactSelectChange={this.handleReactSelectChange}
                      handleDateChange={this.handleDateChange}
                    />

                    <Form
                      style={"clearfix mt-3"}
                      inputs={inputsIdentification}
                      handleChange={this.handleChange}
                      handleReactSelectChange={this.handleReactSelectChange}
                    />
                  <View style={styles.formRow}>
  <View style={styles.flexGrow}>
    <Text size={14} lineHeight={20} marginTop={24} bold>
      Sexo <RequireIndicator />
    </Text>
    <View
      style={styles.genders}
    >
      {this.state.gendersList && Object.entries(this.state.gendersList).length ? (
        Object.entries(this.state.gendersList).map(([key, value], index) => {
          const onPress = () => {
            this.setState({ gender: value }, () => this.removeFromErrors("gender"));
          };
          return (
            <GenderItem
              {...value}
              testID={value.name}
              isChoose={value.id == (this.state.gender && this.state.gender.id)}
              isLastItem={index === Object.entries(this.state.gendersList).length - 1}
              onPress={onPress}
              key={key}
              stylesOverride={{ width: 80, height: 80 }}
            />
          );
        })
      ) : (
        <ActivityIndicator style={CommonStyles.activityIndicator} />
      )}
    </View>

    {this.state.errors.includes("gender") && (
      <Text style={{ color: "red", marginTop: 4, fontSize: 12 }}>
        Debe seleccionar el sexo.
      </Text>
    )}
  </View>
</View>


                    <Form
                      style={"clearfix mt-3"}
                      inputs={inputsInsurance}
                      handleChange={this.handleChange}
                      handleReactSelectChange={this.handleReactSelectChange}
                    />

                    <hr />
                  </div>

                  <h5 className="page-title clear">
                    Ingrese los datos para la confección de la receta
                  </h5>

                  <div
                    className={
                      "clear flex-wrap text-center justify-content-center justify-content-md-around mb-5 " +
                      (errors.includes("medicines") ? "invalid-field p-3" : "")
                    }
                  >
                    {!medicines.length ? (
                      <p>
                        Aún no posee medicamentos seleccionados para esta
                        receta.
                      </p>
                    ) : null}
                    {medicines && medicines.length ? (
                      <div className="card text-secondary border-secondary">
                        <div className="card-header">
                          {locales_es.medicines}
                        </div>
                        <div className="card-body">
                          {medicines.map((medicine, medicineIndex) =>
                            renderMedicine(medicine, medicineIndex)
                          )}
                        </div>
                      </div>
                    ) : null}
                    {medicines && medicines.length >= 3 ? (
                      <p>No puede añadir más medicamentos a esta receta.</p>
                    ) : (
                      <button
                        type="button"
                        onClick={openSearchMedicines}
                        disabled={medicines.length >= 3}
                        className="btn btn-info"
                      >
                        {locales_es.addMedicine}
                      </button>
                    )}
                  </div>

                  {this.state.showTerms && (
                    <div className="form-check">
                      <label
                        className="form-check-label d-inline-flex flex-wrap align-items-center"
                        htmlFor="terms"
                      >
                        <div
                          style={{ marginRight: 2 }}
                          onClick={() => this.handleCheckChange()}
                        >
                          <input
                            id="inputCheckTerms"
                            className="form-control"
                            required={true}
                            type="checkbox"
                            checked={this.state.termsAndPolicy}
                            style={{ marginRight: 2 }}
                          />
                        </div>
                        Al registrarse usted acepta los
                        <a
                          onClick={handleTermsClick}
                          href={this.state.terms}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary text-decoration-none mx-1"
                          style={{ cursor: "pointer" }}
                        >
                          Términos y Condiciones
                        </a>
                        y las
                        <a
                          href={this.state.policies}
                          onClick={handlePoliciesClick}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary text-decoration-none mx-1"
                          style={{ cursor: "pointer" }}
                        >
                          Políticas de Privacidad
                        </a>
                        .
                      </label>
                    </div>
                  )}

                  <div className="clear flex-wrap justify-content-center justify-content-md-around text-center mt-2">
                    <textarea
                      onChange={(e) =>
                        this.setState({
                          comment: e.target.value,
                        })
                      }
                      className="form-control rounded"
                      placeholder={locales_es.observations}
                    >
                      {this.state.observations}
                    </textarea>
                  </div>

                  {/* <div
                    className="clear flex-wrap justify-content-center justify-content-md-around text-center m-5">
                    <div className="custom-control custom-checkbox mb-3">
                      <input type="checkbox"
                             className="custom-control-input"
                             id="termsCheckbox"
                             onChange={(e) => this.setState({acceptedTerms: e.target.checked})}
                             checked={this.state.acceptedTerms}/>
                      <label
                        className={"custom-control-label " + (errors.includes('acceptedTerms') ? 'before-danger' : '')}
                        htmlFor="termsCheckbox">{locales_es.accept} <a
                        href="https://woopi.com.ar" target="_blank">{locales_es.terms}</a></label>
                    </div>
                  </div> */}

                  <div className="clear flex-wrap justify-content-center justify-content-md-around text-center mt-5">
                    <button
                      type="button"
                      onClick={preSendForm}
                      className="btn btn-primary"
                      disabled={this.state.sentRequest}
                    >
                      {locales_es.sendPrescriptionRequest}
                    </button>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>

        {this.state.clinicData ? (
          <Footer
            clinicName={this.state.clinicData.name}
            service={"Servicio de Solicitud de Receta"}
          />
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  genders: {
    marginTop: 24,
    ...Theme.flexRow,
  },
  formRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "baseline",
    gap: 16,
  },
  flexGrow: { flex: 1 },
});
